require('./personeticsTeaserBanner.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const moment = require('moment');

//@commons
const { OKIconTask } = require('commonsComponents/OKIconTask');
const OKTag = require('commonsComponents/OKTag');

class PersoneticsTeaserBanner extends React.Component {

    handleClose = (event) =>  {
        const { immInsight, onClose } = this.props;
        const id = immInsight.get('id');
        onClose(id);
        event.preventDefault();
        event.stopPropagation();
    }

    render() {
        const { immInsight } = this.props;
        const immTeaserInsightBlocks = immInsight.get('teaserBlocks');
        const id = immInsight.get('id');
        const immInsightDate = immTeaserInsightBlocks.find(immBlock => {
            return immBlock.get('blockId') == 'date';
        });
        const insightDate = immInsightDate.get('date');
        const date = moment(insightDate, 'YYYY/MM/DD');
        const day = date.format('DD');
        const month = date.format('MMM').replace('.','');

        const title = immTeaserInsightBlocks.find(immBlock => {
            return immBlock.get('blockId') == 'title';
        }).get('text');
        const description =  immTeaserInsightBlocks.find(immBlock => {
            return immBlock.get('blockId') == 'teaser-text';
        }).get('text');

        const generatedDate = `${day} ${month}`;

        return(
            <div className="personetics-teaser-insight"  onClick={(event) => this.props.onTeaserClick(id, event)}>
                <div className="personetics-teaser-insight__content modal-scroll-container">
                    <div className="row">
                        <div className="col-xs-10">
                            <div className="personetics-teaser-insight__date">
                                <OKTag
                                    content={generatedDate}
                                    type="informative"
                                    context="pill"
                                    emphasis={true}
                                />
                            </div>
                        </div>
                        <div className="col-xs-2">
                            <OKIconTask
                                activeHover={false}
                                icon="icon-cerrar"
                                onClick={this.handleClose}
                                style="dark-bg-alternative"
                                type="circle"
                            />
                        </div>
                    </div>
                    <div className="personetics-teaser-insight__title">
                        {title}
                    </div>
                    <div className="personetics-teaser-insight__description">
                        {description}
                    </div>
                </div>
            </div>
        );
    }
}

PersoneticsTeaserBanner.propTypes = {
    immInsight: PropTypes.object,
    onClose: PropTypes.func,
    onTeaserClick: PropTypes.func,
};

module.exports = PersoneticsTeaserBanner;
